module.exports = __webpack_public_path__ + "img/discount.f22ab0c.png";